import portfolioScroll from './portfolioScroll'
import portfolioScrollToFromWork from './portfolioScrollToFromWork'
import work from './work'
import composeReduxMiddlewares from '../../helpers/composeReduxMiddlewares'

export default composeReduxMiddlewares(portfolioScroll, portfolioScrollToFromWork, work)
